import { X } from "lucide-react";
import React, { useId, useRef } from "react";

import { useDialogFocus } from "@/lib/useDialogFocus";
import { cn } from "@/lib/utils";

/** Окно поверх страницы поставки — вместо `window.confirm`, когда спросить надо больше, чем
 *  «да/нет», или показать причину отказа, не закрывая окна. Esc и клик по подложке закрывают,
 *  фокус держится внутри (`useDialogFocus`). */
export function OzonModal({
  title,
  onClose,
  children,
  className,
}: {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
  className?: string;
}): React.ReactElement {
  const dialogRef = useRef<HTMLDivElement>(null);
  const closeRef = useRef<HTMLButtonElement>(null);
  const titleId = useId();
  useDialogFocus(dialogRef, closeRef, onClose);
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4 dark:bg-black/60"
      onClick={onClose}
    >
      <div
        ref={dialogRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        className={cn(
          "max-h-[90vh] w-full max-w-lg overflow-auto rounded-lg border bg-background p-4 shadow-xl",
          className,
        )}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-3 flex items-start gap-3">
          <h3 id={titleId} className="text-base font-semibold">
            {title}
          </h3>
          <button
            ref={closeRef}
            type="button"
            aria-label="Закрыть"
            className="ml-auto rounded p-1 text-muted-foreground hover:bg-accent hover:text-foreground"
            onClick={onClose}
          >
            <X className="size-4" />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
